"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asTitleCase = void 0;

var _string = require("../type-checks/string");

var asTitleCase = function asTitleCase(input) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$capitalizeAfter = _ref.capitalizeAfter,
      capitalizeAfter = _ref$capitalizeAfter === void 0 ? [] : _ref$capitalizeAfter,
      _ref$excludes = _ref.excludes,
      excludes = _ref$excludes === void 0 ? [] : _ref$excludes;

  // Let return value be input;
  var returnValue = input; // If input is string of length;

  if ((0, _string.isStringOfLength)(input)) {
    // Replace multiple spaces with a single space;
    returnValue = returnValue.replace(/\s(\s+)/g, " "); // Define array of characters to capitalize after;

    var capitalizeAfterCharacters = [" "].concat(capitalizeAfter); // Define lowercase list of excludes for matching;

    var lowerExcludes = excludes.map(function (exclude) {
      return exclude.toLowerCase();
    }); // Lowercase entire string;

    returnValue = returnValue.toLowerCase(); // Iterate over characters;

    capitalizeAfterCharacters.forEach(function (char) {
      // Split, capitalize words, and rejoin;
      returnValue = returnValue.split(char).map(function (word) {
        return lowerExcludes.includes(word.toLowerCase()) ? word.toUpperCase() : word;
      }).map(function (word) {
        return (0, _string.isStringOfLength)(word) ? word.replace(word[0], word[0].toUpperCase()) : "";
      }).join(char);
    });
  } // Return value;


  return returnValue;
};

exports.asTitleCase = asTitleCase;